/** Building zones — floor 0 is the street, negatives are basements, the top
 *  floor is the penthouse, everything between is "the floors". */
import type { RoomType } from '../types';

export type Zone = 'basement' | 'street' | 'upper' | 'penthouse';

export interface ZoneMeta {
  label: string;
  short: string;
  tint: string; // subtle background tint for the floor band
  accent: string;
}

export const ZONE_META: Record<Zone, ZoneMeta> = {
  basement: { label: 'Basement · Cultivation', short: 'BASEMENT', tint: 'rgba(63,174,84,0.05)', accent: '#3fae54' },
  street: { label: 'Street Level · The Drop', short: 'STREET', tint: 'rgba(255,84,112,0.06)', accent: '#ff5470' },
  upper: { label: 'The Floors · Labs & Quarters', short: 'FLOORS', tint: 'rgba(78,168,255,0.04)', accent: '#4ea8ff' },
  penthouse: { label: 'Penthouse', short: 'PENTHOUSE', tint: 'rgba(255,213,74,0.06)', accent: '#ffd54a' },
};

export function zoneOf(floor: number, floorMax: number): Zone {
  if (floor < 0) return 'basement';
  if (floor === 0) return 'street';
  if (floor === floorMax) return 'penthouse';
  return 'upper';
}

/** Which room types are allowed in each zone. Cultivation belongs underground;
 *  the drop needs street access; everything else lives on the floors. */
export const ZONE_ALLOWED: Record<Zone, RoomType[]> = {
  basement: ['grow', 'stash'],
  street: ['deal', 'security'],
  upper: ['lab', 'pack', 'bunk', 'diner', 'rec', 'security', 'stash'],
  penthouse: ['lab', 'pack', 'bunk', 'diner', 'rec', 'security', 'stash'],
};

export function canBuildHere(roomType: RoomType, floor: number, floorMax: number): boolean {
  return ZONE_ALLOWED[zoneOf(floor, floorMax)].includes(roomType);
}
